import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { AbsenceByPolicyDto } from '../../../commonTypes/reports.types';

const useHttpGetPoliciesBreakdown = (month: number, year: number) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<AbsenceByPolicyDto[]>([]);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsReady(false);
        setIsError(false);
        const { exec, abort } = absenceReportApi.getPoliciesBreakdown({
            query: { month, year },
            onSuccess: res => {
                setData(res.body);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [month, year]);

    return { data, isReady, isError };
};

export default useHttpGetPoliciesBreakdown;
